import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { FetchElementAllCategoriesResult, EleViewBackFaceService } from '../../../services/eleview/eleview-backface';
import { ServiceService } from '../../service/service.service';

@Component({
	selector: 'common-label-drawer-for-edit',
	templateUrl: './label-drawer-for-edit.component.html',
	styleUrls: ['./label-drawer-for-edit.component.scss']
})
export class LabelDrawerForEditComponent implements OnInit {
	@HostBinding('class.label-drawer-for-edit') hostClass = true;
	@Output() back = new EventEmitter();
	@Input() category: FetchElementAllCategoriesResult;
	constructor(public svr: ServiceService, public dialog: MatDialog, public eleviewBackFace: EleViewBackFaceService) {}

	ngOnInit() {}
}
